import Mutations from '../../odata/mutations';

export default { ...new Mutations('venue'), ...new Mutations('venues') };
